/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import TarjetaTestimonios from "../../Tarjetas/TarjetaTestimonios";
import {TESTIMONIOS} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Testimonios = () => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        //ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: 1,
                            arrows: true,
                            perMove: 1,
                            pagination: true,
                            width: '100%',
                            drag: 'free',
                            snap: true,
                            interval: 5000,
                            noDrag: true,
                            focus: 'center',
                            type: 'loop',
                            padding: sCell ? 6: '5rem',

                        }}
                    >

                        {TESTIMONIOS.map((item, index) => {
                            return (
                                <SplideSlide key={`qer${index}`}>
                                    <TarjetaTestimonios item={item} />
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Testimonios

const items = [1, 2, 3, 4, 56]